/** Shared drawing space, independent of screen size or pixel density. */
export const DRAWING_WIDTH = 1600;
export const DRAWING_HEIGHT = 1200;
